<template>
  <div class="distributor-card-wrapper">
    <div class="distributor-card">
      <div class="company-info" v-html="distributor.address"></div>
      <div class="contact-info" v-html="distributor.contact"></div>
      <div class="buttons"><a :href="distributor.url" class="btn-dark-grey">Request Information</a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DistributorCard',
  props: {
    distributor: Object
  }
}
</script>
